import React from "react";

interface Props {
  data: any;
}

function Reference({ data }: Props) {
  return (
    <div className="ubbe-card h-100">
      <div className="ubbe-card-header">
        <h5 className="ps-3 mb-0 GlobalBoxHead">Reference</h5>
      </div>
      <div className="card-body pt-2 p-4 h-auto">
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">PO Number</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.purchase_order_no ? data?.purchase_order_no : "N/A"}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">ULD No</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.uld_no ? data?.uld_no : "N/A"}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">GRS No</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.grs_no ? data?.grs_no : "N/A"}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">Waybill No</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.waybill_no ? data?.waybill_no : "N/A"}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">Packing List No</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.packing_list_no ? data?.packing_list_no : "N/A"}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">Cross Reference No</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.cross_reference_no ? data?.cross_reference_no : "N/A"}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">Cross Reference Description</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.cross_reference_description
              ? data?.cross_reference_description
              : "N/A"}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-6">
            <span className="global-text-16">Shipping Order No</span>
          </div>
          <div className="col-md-6 boldglobaltext text-break">
            {data?.shipping_order_no ? data?.shipping_order_no : "N/A"}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reference;
